<template>
  <modal id="editFareGroup"
         :show="showModal"
         modal-classes="modal-dialog-centered modal-lg"
         showClose
         @close="close"
  >
    <template slot="header">
      <h4 class="modal-title">
        {{ $t('fareGroups.edit.titleText') }}
      </h4>
    </template>
    <template>
      <div class="text-center text-muted mb-2">
        <small>{{ $t('fareGroups.edit.helpText') }}</small>
      </div>

      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>

      <form role="form" @submit.prevent="validate()">
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('fareGroups.form.id') }}</label>
          <div class="col-md-9">
            <base-input
              disabled
              :value="formDetails.id">
            </base-input>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('fareGroups.form.description') }}</label>
          <div class="col-md-9">
            <base-input :error="getError('description')">
                <textarea class="form-control"
                          name="description"
                          data-vv-as="'description'"
                          v-validate="modelValidations.required"
                          v-model="formDetails.description"
                          rows="2"/>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('fareGroups.form.free_pt_change_duration') }}</label>
          <div class="col-md-9">
            <base-input
              data-vv-as="'identifier'"
              name="id"
              v-validate="modelValidations.required"
              :error="getError('freePtChangeDuration')"
              v-model="formDetails.freePtChangeDuration">
            </base-input>
          </div>
        </div>
        <div class="text-center">
          <base-button
            type="info"
            :loading="updating"
            class="my-4"
            native-type="submit"
          >{{ $t('fareGroups.edit.actionBtnLabel') }}
          </base-button>
        </div>
      </form>
    </template>
  </modal>
</template>


<script>
  import {BaseAlert, Modal} from 'src/components';
  import {Option, Select} from 'element-ui';
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'edit-fare-group',
    components: {
      [Option.name]: Option,
      [Select.name]: Select,
      Modal,
      BaseAlert
    },
    props: {
      formDetails: {
        type: Object,
        required: true
      },
      show: {
        type: Boolean,
        required: true
      },
    },
    data() {
      return {
        alert: false,
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    computed: {
      ...mapState({
        updating: state => state.fare_group.updating,
        error: state => state.fare_group.error,
      }),
      getActionErrorDetails() {
        return this.error ? this.error.bodyText : null;
      },
      showModal() {
        return this.show == true
      }
    },
    watch: {
      "$store.state.fare_groups.error"(error) {
        this.error = error
      }
    },
    methods: {
      ...mapActions(['UpdateFareGroup']),
      close: function () {
        this.$emit('close');
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.update()
          }
        });
      },
      update: function () {
        let payload = {
          id: this.formDetails.id,
          description: this.formDetails.description,
          details: {
            free_pt_change_duration: this.formDetails.freePtChangeDuration
          }
        }
        this.UpdateFareGroup(payload).then(() => {
          if (this.error != null) {
            this.alert = true
          } else {
            this.$notify({
              type: 'success',
              message: this.$t('fareGroups.edit.updatedNotification', payload),
              icon: 'tim-icons icon-alert-circle-exc'
            })
            this.close()
          }
        });
      }
    }
  }
</script>
